/** Needed for @i18n/next */
"use client";

import { Fragment } from "react";
import type { Formats, TranslationValues } from "use-intl";
import { useTranslations } from "use-intl";

export type I18nMessageProps = {
  formats?: Partial<Formats>;
  message: string;
  values?: TranslationValues;
};

export const I18nMessage = ({ formats, message, values }: I18nMessageProps) => {
  const t = useTranslations();

  return <Fragment>{t(message, values, formats)}</Fragment>;
};
